// Central configuration
export const API_BASE = import.meta.env.VITE_API_URL || '/.netlify/functions/api';
